module.exports = __webpack_public_path__ + "img/placeholder.843cda08.svg";